import React from "react";
import Link from "next/link";
import Footer from "./Footer";
import { useAuth } from "../services/hooks/useAuth";
import { useRequireLogin } from "../services/hooks/useRequireLogin";

export default function RestrictionError({ message }) {
  const { user, isSubscribed } = useAuth();

  const { requireLogin } = useRequireLogin();

  return (
    <>
      <section className="py-12">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8 col-xl-6 text-center">
              <div className="mb-7 font-size-h1">🚫</div>

              <h2 className="mb-5">Restricted</h2>

              <p className="mb-7 text-gray-500">
                {message || `This area is currently restricted.`}
              </p>

              {!isSubscribed ? (
                <Link href="/#subscribe">
                  <a className="btn btn-dark mr-2">Subscribe</a>
                </Link>
              ) : (
                <Link href="/">
                  <a className="btn btn-dark mr-2">Go Home</a>
                </Link>
              )}

              {!user ? (
                <button
                  type="button"
                  role="button"
                  className="btn btn-outline-dark"
                  onClick={requireLogin}
                >
                  Log in
                </button>
              ) : (
                <Link href="/account">
                  <a className="btn btn-outline-dark">Account</a>
                </Link>
              )}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
